<template>
  <div class="popup-menu">
    <ul class="popup-menu__list">
      <li v-for="(item, index) in user.menu.list" :key="index" class="popup-menu__item">
        <router-link :to="item.link" :title="item.title" class="popup-menu__link">
          <p class="popup-menu__text">{{ item.title }}</p>
        </router-link>
      </li>
      <li class="popup-menu__item">
        <div class="popup-menu__link" @click.prevent.stop="logOut">
          <p class="popup-menu__text">Выход</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AppHeaderPopup',
  computed: {
    user () {
      return this.$store.getters.currentUserData
    }
  },
  methods: {
    logOut () {
      this.$emit('log-out')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.popup-menu {
  width: 195px;
  position: relative;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;

  &__item {
    &:last-child {
      .popup-menu__link {
        border-bottom: none;
      }
    }
  }

  &__link {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    min-height: 50px;
    cursor: pointer;
    transition: .3s;
    border-bottom: 1px solid $border_color;

    &:hover {
      background-color: $color__orange;
      color: $color__white;
    }
  }

  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 999;
    top: -8px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 14px;
    height: 14px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(45deg);
  }
}
</style>
